import { createFileRoute } from '@tanstack/react-router';

import { CampaignsPage } from '../features/campaigns/campaigns/CampaignsPage';
import { campaignsRouteSearchSchema } from '../features/campaigns/campaigns/campaignsRouteSearch';

export const Route = createFileRoute('/campaigns/campaigns')({
  validateSearch: campaignsRouteSearchSchema,
  component: CampaignsPage,
});
